import * as PIXI from "pixi.js";
// import { convertSize } from "../utils.js";

const SpriteGenerator = ({
  x = 0,
  y = 0,
  zIndex = 0,
  vx,
  vy,
  width,
  height,
  texture,
  ...options
}) => {
  const sprite = new PIXI.Sprite(texture);

  sprite.width = width;
  sprite.height = height;
  sprite.y = y;
  sprite.x = x;
  sprite.zIndex = zIndex;

  return sprite;
};

export default SpriteGenerator;
